import React from "react";
import { models, service } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import Styles from "./index.module.css";
import PowerBiServices  from "../../../services/PowerBi";

type Props = {
	reportId: string;
};

const PowerBiEmbedCustom = (props: Props) => {
	const { reportId } = props;
	const [reportConfig, setReportConfig] = React.useState<models.IReportEmbedConfiguration>({
		type: "report",
		embedUrl: undefined,
		tokenType: models.TokenType.Embed,
		accessToken: undefined,
		viewMode: models.ViewMode.View,
		permissions: models.Permissions.Read,
		settings: {
			localeSettings: {
				language: "es",
				formatLocale: "es"
			},
			bars: {
				actionBar: {
					visible: false
				}
			},
			panes: {
				filters: {
					expanded: false,
					visible: false
				}
			}
		}
	});

	React.useEffect(() => {
		const fetchReport = async () => {
			PowerBiServices.getReportTokens(reportId).then(response => {
				setReportConfig({
					...reportConfig,
					embedUrl: response.embedUrl,
					accessToken: response.embedToken,
					id: response.reportId
				});
			});
		};

		fetchReport();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [reportId]);

	const eventHandlersMap = new Map([
		[
			"loaded",
			function () {
				console.log("Report has loaded");
			}
		],
		[
			"rendered",
			function () {
				console.log("Report has rendered");
			}
		],
		[
			"saved",
			function () {
				console.log("Report saved");
			}
		],
		[
			"error",
			function (event?: service.ICustomEvent<any>) {
				if(event) {
					console.error(event.detail);
				}
			}
		]
	]);

	return (
		<PowerBIEmbed
			embedConfig={reportConfig}
			eventHandlers={eventHandlersMap}
			cssClassName={Styles.EmbebedReportBI}
		/>
	);
};

export default PowerBiEmbedCustom;
